export default "/images/4744ac6e78412aa9a247b75c768ef98d.png";